import { render, staticRenderFns } from "./dialog-editdeletehashtag.vue?vue&type=template&id=6b54bdc6&"
import script from "./dialog-editdeletehashtag.vue?vue&type=script&lang=js&"
export * from "./dialog-editdeletehashtag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports